module.exports = __webpack_public_path__ + "static/img/NicolasPitois.caf4f0b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/NicolasPitois.jpg
// module id = grCu
// module chunks = 1